import { Typography, } from '@mui/material';

const AboutPage = () => {
    return (
        <>
            <Typography
                sx={{
                    fontSize: [18, 21, 24, 27],
                    fontWeight: 700,
                    mb: [3, 4, 5, 6],
                }}>О проекте</Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: 14, }}>Учебная платформа специально разработанная для тех, кто хочет получить максимальную эффективность от обучения в короткие сроки</Typography>
        </>
    );
};

export default AboutPage;